
import React, { MouseEvent, useEffect, useState } from 'react';

import { injectIntl, IntlShape } from 'react-intl';

import { addMonths, parse, format } from 'date-fns';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setReservationForm } from 'redux/actions/reservationsActions';
import { setRefresh } from 'redux/actions/pageActions';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Icon from "@mui/material/Icon";

// Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import VerticalCalendar from 'components-lib/VerticalCalendar/VerticalCalendar';

// icon
import { reservationIconWhite } from 'assets/icons';

// enumns
import { reservationStatusEditEnum } from 'common/enums/DevicesStateEnum';
import { reservationStatusApprovedEditEnum } from 'common/enums/DevicesStateEnum';
import { reservationFineEditEnum } from 'common/enums/DevicesStateEnum';

// types
import { ReservationData, ReservationDataForm } from 'types/typesRedux';

type Props = {
  intl: IntlShape,
  onEditReservation?: (key: string, bool: boolean) => void,
  onCloseWindow?: (type: string, bool: boolean) => void,
}

const EditReservation = ( {intl, onEditReservation, onCloseWindow}: Props) => {
  
  const dispatch = useDispatch();

  // const { enqueueSnackbar } = useSnackbar();

  const reservation = useSelector( (state: ReservationData) => state.reservationDetail.reservation );
  const reservationForm = useSelector( (state: ReservationDataForm) => state.reservationDetail.reservationForm );

  useEffect(() => {

    const parsedDate = parse(reservation.startAt, "dd.MM.yyyy HH:mm", new Date());
    const timeOnly = format(parsedDate, "HH:mm");
    const dateOnly = format(parsedDate, "dd.MM.yyyy");

    dispatch(setReservationForm({
      status: '',
      issueFine: null,
      date: dateOnly,
      time: timeOnly,
    }));
  }, []);

  // delete data from form and send 'false' parent to close window
  const closeWindow = () => {
    onCloseWindow( 'editReservation', false );
    dispatch(setReservationForm( {
      status: '',
      issueFine: null,
      date: null,
      time: null,
    } 
    ));
  } 

  // If submit, edit reservation
  const handleSubmit = async (e: MouseEvent<HTMLButtonElement> ) => {
    e.preventDefault();
    onEditReservation('newDateTime', true)
    onCloseWindow( 'editReservation', false );
  };

  const [isCalendar, setIsCalendar] = useState<boolean>(false);

  const handleInputDescription = ( newValue: string, type?: 'date' | 'time' ) => {

    if (type === 'time') {
      dispatch(setReservationForm({
        ...reservationForm,
        time: newValue,
      }));
    } else if (type === 'date') {
      dispatch(setReservationForm({
        ...reservationForm,
        date: newValue,
      }));
    }
  };

  return (
    <>
      <Grid container sx={{ position: 'fixed', top: '0%', left: '0%',
        backgroundColor:"rgba( 0, 0, 0, 0.5 ) !important", 
        width:"100vw", height:"100vh", zIndex:"1300" }}
      >

        <MDBox
          sx={{
            display: "flex", flexDirection: "row",
          }}
        >

          <Card
            sx={{ 
              minWidth: "24rem", width: "auto", maxWidth: "27rem",
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              // backgroundColor: "#5ada55",
            }}
          >        

            <MDBox
              display="flex"
              flexDirection="column"
              p={2}
              m={0}
              sx={{ listStyle: "none" }}
            >    

              <MDBox sx= {{ display: "flex",
                flexDirection: "row", gap: "1rem" }} 
              >
                <MDBox className= "badge"
                  sx={{ 
                    // backgroundColor: "#17C063",
                    p: 1, mt: -4, ml: 0,
                    borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
                  }}
                  display="grid"
                  justifyContent="center"
                  alignItems="center"
                  bgColor="#17C063"
                  color="white"
                  width="4.5rem"
                  height="4.5rem"
                  shadow="md"
                  borderRadius="lg"
                  variant="gradient"  
                  fontSize= "2.2rem"        
                >
                  {reservationIconWhite}
                </MDBox>

                <MDBox
                  sx={{
                    diplay: "flex", flexDirection: "column",
                  }}
                >
                  <MDTypography
                    sx={{
                      fontSize: "1.2rem", fontWeight: "700",
                    }}
                  >
                    {intl.formatMessage({id:'reservationDetail.title'})}
                  </MDTypography>
                  <MDTypography
                    sx={{
                      fontSize: "0.75rem", fontWeight: "400",
                      color: "#7B809A",
                    }}
                  >
                    {reservation?.id}
                  </MDTypography>
                </MDBox>
                                
              </MDBox>

              <MDBox
                sx={{
                  display: "flex", flexDirection: "row",
                  justifyContent: "space-between", alignItems: "center",
                  paddingBottom: "0.8rem", paddingTop: "0.8rem",
                }}
              >
                <MDTypography
                  sx={{
                    fontSize: "0.85rem", fontWeight: "700",
                    width: "45%", paddingLeft: "1rem"
                  }}
                >
                  {intl.formatMessage({id:'reservationEdit.date'})}
                </MDTypography>

                  <MDInput
                    type="text"
                    name="date"
                    placeholder={reservationForm.date}
                    // disabled={isDisabled}
                    value={ reservationForm.date }
                    // onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputDescription(e, e.target.value, 'date')}
                    // onChange={() => setIsCalendar(true)}
                    onClick={() => setIsCalendar(true)}
                    inputProps={{
                      maxLength: 20,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#D2D6DA',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        color: '#7B809A',
                        opacity: 1,
                      },
                    }}
                    style={{ width: "45%", }}
                  />
              </MDBox>

              <MDBox
                sx={{
                  display: "flex", flexDirection: "row",
                  justifyContent: "space-between", alignItems: "center",
                  paddingBottom: "0.8rem", paddingTop: "0.8rem",
                }}
              >
                <MDTypography
                  sx={{
                    fontSize: "0.85rem", fontWeight: "700",
                    width: "45%", paddingLeft: "1rem"
                  }}
                >
                  {intl.formatMessage({id:'reservationEdit.time'})}
                </MDTypography>

                <Autocomplete
                  options={ ['08:00', '13:00'] }
                  onChange={(_, value) => handleInputDescription(value, 'time')}
                  disableClearable
                  sx={{ marginTop: "-0.5rem", width: "45%", }}
                  ListboxProps= {{
                    sx: {
                      "& div": {  minWidth: "25rem !important", width: "100%"  },
                      "& li": {  marginLeft: "-0.75rem", marginRight: "0rem", fontSize: "0.85rem !important", borderRadius: "none", },
                      // "& li:last-child": { color: "#000", backgroundColor: "#FF7866", borderRadius: "0px", fontWeight: "400"},
                    }
                  }}
                  renderInput={(params: any) => (
                    <MDInput
                      className="autocomplete"
                      {...params}
                      right={'16px'}
                      left={'-5px'}
                      InputLabelProps={{ shrink: false }}
                      sx={{
                        width: "100%",
                        '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
                          marginRight: 0, 
                          right: "5px",
                        '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment:hover': {
                          cursor: "pointer",
                          /* Define other hover styles as needed */
                        },
                        },
                        '& button': {
                          paddingRight: "0rem",
                          paddingLeft: "0rem",
                        },
                      }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          paddingRight: '0', 
                          paddingLeft: '0.3rem', 
                          fontSize: '0.75rem', 
                        },
                        readOnly: true,
                      }}
                      size="small"
                      label={!params.inputProps.value ? reservationForm.time : ""}
                      variant="outlined"
                    />
                  )}
                />
              </MDBox>

              <MDBox 
                sx={{
                    display: "flex", flexDirection: "row", justifyContent: "flex-end", 
                    gap: "0.5rem", maxWidth: "100%", marginBottom: "0.5rem", marginTop: "1rem",
                }}
              >
                <MDButton 
                  variant="outlined" 
                  color="success" 
                  onClick={ closeWindow }
                >
                  {intl.formatMessage({id:'button.cancel'})}
                </MDButton>
                <MDButton
                  variant="contained" 
                  color="success" 
                  onClick={ handleSubmit }                  
                >
                  {intl.formatMessage({id:'button.save'})}
                </MDButton>
              </MDBox>
      
            </MDBox>
          </Card>
          { isCalendar && (
            <MDBox
              sx={{
                position: 'fixed',
                top: '50%',
                left: 'calc(50% + 13rem)', 
                transform: 'translateY(-50%)',
                zIndex: 1301,
              }}
            >
              <VerticalCalendar
                endDate={format(addMonths(new Date(), 4), 'yyyy-MM-dd')}
                setIsCalendar={setIsCalendar}
                handleInputDescription={handleInputDescription}
              />
            </MDBox>
          )}
        </MDBox>
      </Grid>

    </>
  )
};

export default injectIntl(EditReservation);